import Pane from 'components/Common/Pane'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import LoyaltyAccountLandingPageBenefitItem from './LoyaltyAccountLandingPageBenefitItem'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import BodyText from 'components/Luxkit/Typography/BodyText'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import Divider from 'components/Luxkit/Divider'

const Section = styled(Pane)`
  padding: ${rem(24)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(24)};
  }
`

function LoyaltyAccountLandingPageYourBenefits() {
  const account = useAppSelector(state => state.loyalty.account.data)
  const [, tierName] = useCurrentLoyaltyTier()

  return <Section>
    <VerticalSpacer gap={12}>
      <VerticalSpacer gap={2}>
        <Heading variant="heading3">Your {tierName} <i>benefits</i></Heading>
        {!!account?.statusReviewDate && <BodyText variant="medium">
          Expire <FormatDateTime value={account.statusReviewDate} format="dmy-casual" />
        </BodyText>}
      </VerticalSpacer>
      <VerticalSpacer gap={8}>
        {account?.benefits.map((benefit, index) => <React.Fragment key={benefit.code}>
          {index !== 0 && <Divider kind="secondary" />}
          <LoyaltyAccountLandingPageBenefitItem
            key={benefit.code}
            benefit={benefit}
          />
        </React.Fragment>)}
      </VerticalSpacer>
    </VerticalSpacer>
  </Section>
}

export default LoyaltyAccountLandingPageYourBenefits
